import { LegalPage } from "../components/LegalPage";
import { site } from "../config/site";

export default function PolitiqueConfidentialite() {
  return (
    <LegalPage
      title="Politique de confidentialité | TN FOOD"
      description="Politique de confidentialité de TN FOOD : données collectées, finalités, durées de conservation, droits RGPD et cookies."
      path="/politique-de-confidentialite"
      updated="janvier 2026"
    >
      <h2>1. Responsable du traitement</h2>
      <p>
        TN FOOD, SAS au capital de {site.capital}, {site.address.full} — {site.rcs}.<br />
        Contact : <a href={`mailto:${site.email}`}>{site.email}</a>.
      </p>

      <h2>2. Données collectées</h2>
      <p>Via les formulaires du site (réservation, devis traiteur, contact) :</p>
      <ul>
        <li>type de demandeur et type d'événement ;</li>
        <li>société ou organisation (le cas échéant) ;</li>
        <li>nom et prénom, email, téléphone ;</li>
        <li>date et heure souhaitées, date et lieu de l'événement ;</li>
        <li>nombre de personnes ou de convives ;</li>
        <li>type de prestation, options souhaitées, contraintes alimentaires, budget indicatif, description du projet ;</li>
        <li>canal d'acquisition (« comment nous avez-vous connu ? »).</li>
      </ul>
      <p>Via la navigation : adresse IP, journaux techniques (logs), type de navigateur.</p>

      <h2>3. Finalités et bases légales</h2>
      <ul>
        <li>Traitement des réservations et demandes de devis : exécution de mesures précontractuelles et intérêt légitime ;</li>
        <li>Gestion de la relation client, facturation, obligations HACCP et traçabilité alimentaire : exécution du contrat et obligation légale ;</li>
        <li>Prospection commerciale : consentement (case dédiée) ou intérêt légitime ;</li>
        <li>Sécurité du site : intérêt légitime ;</li>
        <li>Respect des obligations comptables et fiscales : obligation légale.</li>
      </ul>

      <h2>4. Durées de conservation</h2>
      <ul>
        <li>Devis non aboutis : 3 ans ;</li>
        <li>Données clients : durée de la relation commerciale + 10 ans (obligations comptables) ;</li>
        <li>Prospection : 3 ans à compter du dernier contact ;</li>
        <li>Cookies : 13 mois maximum ;</li>
        <li>Journaux techniques : 12 mois maximum ;</li>
        <li>Traçabilité alimentaire : 6 mois minimum, conformément aux obligations légales.</li>
      </ul>

      <h2>5. Destinataires et transferts</h2>
      <p>
        Les données sont destinées au Président de TN FOOD et au personnel habilité, ainsi qu'à nos sous-traitants :
        hébergeur (Namecheap), prestataire d'envoi d'emails, et le cas échéant prestataires traiteur partenaires, avec
        votre accord préalable. L'hébergement étant assuré par Namecheap (États-Unis), les éventuels transferts hors de
        l'Union européenne sont encadrés par des clauses contractuelles types et/ou le Data Privacy Framework.
      </p>

      <h2>6. Vos droits</h2>
      <p>
        Vous disposez des droits d'accès, de rectification, d'effacement, de limitation, d'opposition, de portabilité
        et de retrait de votre consentement. Pour les exercer : <a href={`mailto:${site.email}`}>{site.email}</a>.
      </p>
      <p>
        Vous pouvez introduire une réclamation auprès de la CNIL : cnil.fr — 3 Place de Fontenoy, TSA 80715, 75334
        Paris Cedex 07.
      </p>

      <h2>7. Cookies</h2>
      <p>
        Le site utilise des cookies strictement nécessaires à son fonctionnement et, avec votre accord, des cookies
        non essentiels de mesure d'audience. Le bandeau de consentement vous permet d'accepter, de refuser ou de
        personnaliser vos choix, avec une égale visibilité des options et aucune case pré-cochée. Vous pouvez modifier
        votre choix à tout moment via le lien « Gérer mes cookies » en pied de page.
      </p>

      <h2>8. Sécurité</h2>
      <p>
        Nous mettons en œuvre des mesures techniques et organisationnelles appropriées : chiffrement HTTPS, contrôle
        des accès, sauvegardes régulières.
      </p>

      <h2>9. Mineurs</h2>
      <p>Le site et ses formulaires sont destinés aux personnes majeures.</p>

      <h2>10. Modification de la présente politique</h2>
      <p>
        La présente politique peut être mise à jour à tout moment. La version applicable est celle publiée sur cette
        page.
      </p>

      <h2>11. Contact</h2>
      <p>
        Pour toute question relative à vos données personnelles : <a href={`mailto:${site.email}`}>{site.email}</a> —{" "}
        <a href={site.phoneHref}>{site.phone}</a>.
      </p>
    </LegalPage>
  );
}
